import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import SignIn from "./components/authentication/SignIn";
import SignUp from "./components/authentication/SignUp";
import ResetPassword from "./components/authentication/ResetPassword";

import AdminAll from './components/administration/AdminAll';
import UserAdmin from './components/administration/UserAdmin';
import UserInfo from './components/administration/UserInfo';
import MonthlyPay from './components/administration/MonthlyPay';
import WeeklyPay from './components/administration/WeeklyPay';
import ManageOrders from './components/administration/ManageOrders';
import Statistics from './components/administration/Statistics';

import GeneralArithmeticQuiz from './components/arithmetic/GeneralArithmeticQuiz';
import GeneralArithmeticQuizQuestion from './components/arithmetic/GeneralArithmeticQuizQuestion';
import GeneralArithmeticQuizResult from './components/arithmetic/GeneralArithmeticQuizResult';
import ArithmeticQuiz from './components/arithmetic/ArithmeticQuiz';
import ArithmeticQuizQuestion from './components/arithmetic/ArithmeticQuizQuestion';
import ArithmeticQuizResult from './components/arithmetic/ArithmeticQuizResult';
import ArithmeticGrade7 from './components/arithmetic/ArithmeticGrade7';

import EnglishWords from './components/language/EnglishWords';
import Dictionary from './components/language/Dictionary';
import GeneralPronunciation from './components/language/GeneralPronunciation';

import DrawingBoard from './components/drawings/DrawingBoard';

import MemoryGame from './components/memory/MemoryGame';

import PuzzleGame from './components/puzzles/PuzzleGame';

import Orders from "./components/public/Orders";
import Main from "./components/public/Main";


import HowToEarn from "./components/HowToEarn";
import Website from "./components/Website";
import Profile from "./components/administration/Profile";
import UserProfilePopup from "./components/administration/UserProfilePopup";
import AccountPage from "./components/AccountPage";
import AccountSettings from "./components/AccountSettings";
import Income from "./components/Income";
import UserStatistics from "./components/UserStatistics";
import Payments from "./components/Payments";
import EditProfile from './components/EditProfile';



function App() {

  
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/service-worker.js')
          .then(registration => {
            console.log('Service Worker registered: ', registration);
          })
          .catch(error => {
            console.log('Service Worker registration failed: ', error);
          });
      });
    }
  }, []);




  return (
    
      <Router>
     
        <Routes>

          // Authentication Pages
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          // Admin Pages
          <Route path="/user-admin/:userId" element={<UserAdmin />} />
          <Route path="/user-info" element={<UserInfo />} />        
          <Route path="/weekly-pay" element={<WeeklyPay />} />
          <Route path="/monthly-pay" element={<MonthlyPay />} />
          <Route path="/manage-orders" element={<ManageOrders />} />
          <Route path="/statistics" element={<Statistics />} />

          // Arithmetic
          <Route path="/general-arithmetic-quiz" element={<GeneralArithmeticQuiz />} />
          <Route path="/general-arithmetic-quiz-question" element={<GeneralArithmeticQuizQuestion />} />
          <Route path="/general-arithmetic-quiz-result" element={<GeneralArithmeticQuizResult />} />
          <Route path="/arithmetic-quiz" element={<ArithmeticQuiz />} />
          <Route path="/arithmetic-quiz-question" element={<ArithmeticQuizQuestion />} />
          <Route path="/arithmetic-quiz-result" element={<ArithmeticQuizResult />} />
          <Route path="/arithmetic-qrade-seven" element={<ArithmeticGrade7 />} />

          // language
          <Route path="/dictionary" element={<Dictionary />} />
          <Route path="/english-words" element={<EnglishWords />} />
          <Route path="/general-pronunciation" element={<GeneralPronunciation />} />

          //drawings
          <Route path="/drawing-board" element={<DrawingBoard />} />

          //memory
          <Route path="/memory-game" element={<MemoryGame />} />

          //puzzle
          <Route path="/puzzle-game" element={<PuzzleGame />} />

          //public
          <Route path="/main" element={<Main />} />
         
          //User Pages
          <Route path="/profile/:userId" element={<Profile />} />
          <Route path="/user-statistics/:userId" element={<UserStatistics />} />
          <Route path="/account-settings/:userId" element={<AccountSettings />} />
          <Route path="/how-to-earn/:userId" element={<HowToEarn />} />
          <Route path="/website/:userId" element={<Website />} />

       
          <Route path="/*" element={<Main />} /> {/* Default route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
       
      </Router>
    
  );
}



function NotFound() {
  return (
    <div>
      <h2>404 - Not Found</h2>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}

export default App;
